import { Component, OnInit } from '@angular/core';
import { UsersService } from "../../../injections/users.service";
import {Router} from "@angular/router";

@Component({
    moduleId: module.id,
    selector: 'main-users',
    templateUrl: '../templates/main-users.html',
    providers: [UsersService],
})

export class MainUsersComponent implements OnInit {

    public results;
    constructor(private usersService: UsersService, private router: Router) {}

    public createUser(object){
    }

     public searchByCif(value) {
         //console.log(value);
         this.usersService.findUserByCif(value).subscribe(result => {
            this.results = result;
         });
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/users/components/main-users.component.ts